// extracted by mini-css-extract-plugin
export default {"wrapper":"f2mZI_tyeq68uYsa5byd"};